import * as R from 'ramda'

import { agents, tasks, properties} from './entities'
let attachments = state => state.attachments

export default (state) => (id) => {
	let agent = agents(state)[id]

	if(!agent) return undefined
	return({
		...agent
	  , tasksActive: R.values(R.filter(task => !!~agent.tasks.indexOf(task._id) && !task.done, tasks(state)))
	  , tasksDone: R.values(R.filter(task => !!~agent.tasks.indexOf(task._id) && task.done, tasks(state)))
	  , properties: R.values(R.filter(prop => prop.agentID === id, properties(state)))
	  , comments: (agent.comments)?R.map(
			commentData =>({
				...commentData
			  , attachments: (commentData.attachmentsIDs)?
					R.map(
						attachmentID =>
							(attachments(state)[agent._id]
							&& attachments(state)[agent._id].attachments[attachmentID.id])?
								attachments(state)[agent._id].attachments[attachmentID.id]
								: false
						, commentData.attachmentsIDs
					)
					: {}
			})
			, agent.comments)
			: []
	})
}



// WEBPACK FOOTER //
// ./src/selectors/agent.js